import React from 'react';
import Button from '@mui/material/Button';
import RecordBase from './../tools/RecordBase';
import app from '../base/api';

class Cotizacion extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'cotizaciones';
    this.title = 'Cotizacion';
  }

  calculate = async () => {
    let res = await app.get('/api/calculate/' + this.state.id);
    console.log(res)
  }

  /*buttonActions = () => {
    var res = [];
    res.push(
        <Button
          key="calculate"
          type="button"
          onClick={this.calculate}
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Calcular
        </Button>
    )
    return res;
  }*/


}

export default Cotizacion;
